export const mutations = {
  setDrivers(state, drivers) {
    state.drivers = drivers;
  },
  setDriversById(state, driversById) {
    state.driversById = driversById;
  },
};
